import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@material-ui/core";
import t from "../../languages/pl";
import CancelAcceptForm from './CancelAcceptForm';

const useStyles = theme => ({
    content: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: theme.spacing(3)
    }
});

const AdditionalInformationDialog = props => {
    const { classes, id, action, additionalText, open, onClose, onSubmit } = props;

    const handleSubmit = () => {
        if(onSubmit)
            onSubmit(id);
        onClose();
    };

    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth="sm"
            onClose={onClose}
        >
            <DialogTitle>
                {t.info}
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Typography variant="subtitle1">
                    {action}
                    {additionalText ? <Fragment> <br/> <br/> {additionalText}</Fragment> : null}
                </Typography>
            </DialogContent>
            <DialogActions>
                <CancelAcceptForm onCancel={onClose} onSubmit={handleSubmit} />
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(useStyles)(AdditionalInformationDialog);

AdditionalInformationDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    action: PropTypes.string,
    additionalText: PropTypes.string,
    onSubmit: PropTypes.func
};